var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EChart',{attrs:{"loading":_vm.loading,"height":_vm.chart.height,"option":_vm.chart.option,"annotations":_vm.annotations}})
}
var staticRenderFns = []

export { render, staticRenderFns }